import { backendServices, RecursivePartial } from 'common';
import { BuyerSignupFormData } from '../../pages/Buyer/buyersignup.types';
import { convertFormToViewModel } from './CompanyService.utils';

export class CompanyService {
    private api = new backendServices.Apis.CompanyApi();

    async getSupplierCompanyInformation(search: string, registrationCode: string) {
        const response = await this.api.getCompanyBySearchString(search, { registrationCode });

        const companyInfo = response.data[0] ?? null;

        if (companyInfo == null) {
            return null;
        }

        return companyInfo;
    }

    async getCompanyInformation(search: string) {
        const response = await this.api.getCompanyBySearchString(search);

        const companyInfo = response.data[0] ?? null;

        if (companyInfo == null) {
            return null;
        }

        return this.extractPublicData(companyInfo);
    }

    private extractPublicData(vm: backendServices.ViewModels.CompanyViewModel) {
        const {
            ID,
            InvitationLink,
            RegistrationMessage,
            RegistrationMessage1,
            RegistrationMessage2,
            RegistrationMessage3,
            RegistrationVideo,
            ManualInvoiceThreshold,
            RegistrationUrlIdentifier,
            Name,
            Logo,
            Attributes,
            OsnRequired,
            RegistrationContact,
        } = vm;

        return {
            ID,
            Name,
            Logo,
            InvitationLink,
            RegistrationMessage,
            RegistrationMessage1,
            RegistrationMessage2,
            RegistrationMessage3,
            RegistrationVideo,
            ManualInvoiceThreshold,
            RegistrationUrlIdentifier,
            Attributes,
            OsnRequired,
            RegistrationContact,
        };
    }

    async getSubmissionMethods(companyId: number) {
        const response = await this.api.getSubmissionMethod({ companyId });

        const methods = response.data;

        return methods;
    }

    async registerBuyerCompanyUserProfile(
        formData: BuyerSignupFormData,
        baseViewModel: RecursivePartial<backendServices.ViewModels.BuyerCompanyUserProfileViewModel>
    ) {
        const viewModel = convertFormToViewModel(formData, baseViewModel);

        const response = await this.api.postBuyerCompanyUserProfile(viewModel);

        return response.status;
    }
}
